module.exports = __webpack_public_path__ + "static/media/DSC_0565.c4af5aeb.JPG";